export class SetPageRefreshFlag {
  static type = '[Goals] Needs Page Resfresh On Manage Campaigns Modal Close';

  constructor(readonly refreshOnManageCampaignsClose: boolean) {}
}
